import { ICellRendererComp, ICellRendererParams } from 'ag-grid-community';

export type AsyncCellParams = ICellRendererParams & { promise: (params: AsyncCellParams) => Promise<string> };

export class AsyncCellComponent implements ICellRendererComp {
  private eGui!: HTMLElement;

  public getGui(): HTMLElement {
    return this.eGui;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public refresh(_params: AsyncCellParams): boolean {
    return true;
  }

  public init(params: AsyncCellParams): void {
    this.eGui = document.createElement('div');
    // daisy ui skeleton
    this.eGui.innerHTML = '<div class="skeleton h-4 w-full"></div>';
    params.promise(params).then((value) => {
      // after promise is resolved, set the value and refresh cell
      this.eGui.innerHTML = value;
      if (params?.refreshCell) params.refreshCell();
    });
  }
}
